export enum QUERY_KEY {
  GET_RENTAL_INFO = 'GET_RENTAL_INFO',
  GET_PAYMENT_INFO = 'GET_PAYMENT_INFO',
  GET_RENTAL_STATE = 'GET_RENTAL_STATE',
  GET_LOGGED_IN_USER_INFO = 'GET_LOGGED_IN_USER_INFO',
  GET_APP_BANNER_SETTING_BY_IMEI_OR_SERIAL = 'GET_APP_BANNER_SETTING_BY_IMEI_OR_SERIAL',
  GET_STATION_STATUS_BY_IMEI_OR_SERIAL = 'GET_STATION_STATUS_BY_IMEI_OR_SERIAL',
  GET_STATION_PRICING = 'GET_STATION_PRICING',
  GET_STATION_PRICINGS = 'GET_STATION_PRICINGS',
  GET_ACCOUNT_BALANCES = 'GET_ACCOUNT_BALANCES',
  GET_STATION_VENUE_COUNTRY_CODE = 'GET_STATION_VENUE_COUNTRY_CODE',
  GET_USER_SUBSCRIPTION_BY_PHONE_NUMBER = 'GET_USER_SUBSCRIPTION_BY_PHONE_NUMBER',
  GET_CURRENT_SUBSCRIPTION = 'GET_CURRENT_SUBSCRIPTION',
  GET_USER_PASS_DETAIL = 'GET_USER_PASS_DETAIL',
  GET_ONGOING_RENTAL = 'GET_ONGOING_RENTAL',
  LIST_CAMPUS_INSTITUTIONS = 'LIST_CAMPUS_INSTITUTIONS',
  GET_USER_PAYMENT_METHODS = 'GET_USER_PAYMENT_METHODS',
  GET_STATION_INFORMATION = 'GET_STATION_INFORMATION',
  GET_CAMPUS_CARD_INSTITUTION = 'GET_CAMPUS_CARD_INSTITUTION',
  GET_CAMPUS_CARD_BALANCE = 'GET_CAMPUS_CARD_BALANCE',
  GET_TENANT_INFO = 'GET_TENANT_INFO',
}

export enum PAGE_HOST_KIND {
  CF_DIRECT = 'CF_DIRECT',
  TENANT = 'TENANT',
  LOCAL = 'LOCAL',
  UNKNOWN = 'UNKNOWN',
}

export enum STEP {
  INPUT_PHONE_NUMBER = 'INPUT_PHONE_NUMBER',
  INPUT_OTP = 'INPUT_OTP',
  INPUT_PAYMENT_INFO = 'INPUT_PAYMENT_INFO',
}

export enum PAYMENT_STEP {
  RENT_A_CHARGER = 'RENT_A_CHARGER',
  SELECT_PAYMENT_METHOD = 'SELECT_PAYMENT_METHOD',
  ADD_PAYMENT_METHOD = 'ADD_PAYMENT_METHOD',
  ADD_PROMO_CODE = 'ADD_PROMO_CODE',
  FUZE_CASH_BALANCES = 'FUZE_CASH_BALANCES',
  AVAILABLE_SWAPS = 'AVAILABLE_SWAPS',
  SELECT_PRICING_MODELS = 'SELECT_PRICING_MODELS',
  CAMPUS_CARD_LIST = 'CAMPUS_CARD_LIST',
  ADD_CAMPUS_CARD = 'ADD_CAMPUS_CARD',
  PASS_DETAIL = 'PASS_DETAIL',
}

export enum PAYMENT_METHOD {
  CREDIT_CARD = 'CREDIT_CARD',
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
}

export enum PAYMENT_GATEWAY {
  STRIPE = 'STRIPE',
  CAMPUS_CARD = 'CAMPUS_CARD',
}

export enum CAMPUS_CARD_AUTH_TYPE {
  DIRECT = '1',
  SSO = '2',
}

export enum RENTAL_STATE {
  WAITING = 'WAITING',
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED',
  OVERDUE = 'OVERDUE',
  FAILED = 'FAILED',
}

export enum API_ENDPOINT_KEYS {
  SEND_CODE = 'SEND_CODE',
  VERIFY_CODE = 'VERIFY_CODE',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  GET_PROFILE = 'GET_PROFILE',
}

export enum RentalFailedReason {
  /**
   * Indicate that the rental failed because there was no any rentable battery inside station at that time
   */
  NO_RENTABLE_BATTERY = 'NO_RENTABLE_BATTERY',

  /**
   * Indicate that the rental failed because service could not invoke the Iot Event
   * Station may offline or the connection between BE and Alibaba Iot has been dropped
   */
  FAILED_TO_INVOKE_IOT = 'FAILED_TO_INVOKE_IOT',

  /**
   * Indicate that the rental failed because the station can not eject the battery
   */
  STATION_CAN_NOT_EJECT_BATTERY = 'STATION_CAN_NOT_EJECT_BATTERY',

  /**
   * Indicate that the rental failed because the pre-auth process has been failed
   */
  PRE_AUTH_PAYMENT_FAILED = 'PRE_AUTH_PAYMENT_FAILED',

  /**
   * Indicate that the rental failed because that we did not hear any response of station after a while
   */
  TIMED_OUT = 'TIMED_OUT',

  /**
   * Indicate that the rental failed because the station is offline
   */
  STATION_OFFLINE = 'STATION_OFFLINE',
}

export const SERVICE_AUTH_ENDPOINTS: { [key in API_ENDPOINT_KEYS]: string } = {
  [API_ENDPOINT_KEYS.SEND_CODE]: 'api/v1/auth/send-code',
  [API_ENDPOINT_KEYS.VERIFY_CODE]: 'api/v1/auth/verify-code',
  [API_ENDPOINT_KEYS.REFRESH_TOKEN]: 'api/oauth2/token',
  [API_ENDPOINT_KEYS.GET_PROFILE]: 'api/v1/user/me',
};

export const SERVICE_AUTH_V2_ENDPOINTS: { [key in API_ENDPOINT_KEYS]: string } =
  {
    [API_ENDPOINT_KEYS.SEND_CODE]: 'api/v2/auth/send-code',
    [API_ENDPOINT_KEYS.VERIFY_CODE]: 'api/v1/auth/verify-code',
    [API_ENDPOINT_KEYS.REFRESH_TOKEN]: 'api/oauth2/token',
    [API_ENDPOINT_KEYS.GET_PROFILE]: 'api/v1/user/me',
  };

export const RENTAL_FAILED_REASON: Record<string, string> = {
  [RentalFailedReason.NO_RENTABLE_BATTERY]:
    'All batteries are currently recharging. Please try again later.',
  [RentalFailedReason.FAILED_TO_INVOKE_IOT]:
    'Error when communicating with station',
  [RentalFailedReason.PRE_AUTH_PAYMENT_FAILED]:
    'Can not process pre-auth payment for this rental',
  [RentalFailedReason.TIMED_OUT]: 'Request timed out',
};

export enum FEATURE_FLAGS {
  'CONFIGURABLE_WEB_APP_BANNER' = 'CONFIGURABLE_WEB_APP_BANNER',
  'WEB_APP_CHECK_RATE_LIMIT' = 'WEB_APP_CHECK_RATE_LIMIT',
  'NEW_WEB_APP_PAYMENT_FLOW' = 'NEW_WEB_APP_PAYMENT_FLOW',
  'WEB_APP_PHONE_NUMBER_UI_REVAMP' = 'WEB_APP_PHONE_NUMBER_UI_REVAMP',
  'WEB_APP_DUAL_PRICING_FLOW' = 'WEB_APP_DUAL_PRICING_FLOW',
  'CLIENT_USE_UNIFIED_REQUEST_BATTERY_API' = 'CLIENT_USE_UNIFIED_REQUEST_BATTERY_API',
  'MULTI_CARDS_PER_USER_BY_WEB_PLATFORM' = 'MULTI_CARDS_PER_USER_BY_WEB_PLATFORM',
  'CAMPUS_CARD_BY_WEB_PLATFORM' = 'CAMPUS_CARD_BY_WEB_PLATFORM',
  'WEB_APP_SUBSCRIPTION_PASS' = 'WEB_APP_SUBSCRIPTION_PASS',
}

export enum BROWSER {
  SAFARI = 'Safari',
  CHROME = 'Chrome',
  OTHER = 'Other',
}

export enum DEVICE_TYPE {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  COMPUTER = 'COMPUTER',
}
